import type { ReactElement } from "react";
import { CmtsUsersPage } from "../../pages/cmtsUsersPage.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(_props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsUsersPage />;
}

export default Component;
